import React from 'react'

import { Snackbar as MuiSnackbar, Slide } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'

export default function Snackbar({ open, onClose, severity, message }) {
  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      onClose={onClose}
      autoHideDuration={5000}
      TransitionComponent={Slide}
    >
      <Alert variant="filled" severity={severity}>
        {message}
      </Alert>
    </MuiSnackbar>
  )
}
